export const label = {
  marginLeft: '1em',
}
